import Component, { mixins } from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import PropertyCommons from '../commons/property.model';

@Component({
  inheritAttrs: false,
})
export default class InputSelectOneComponent extends mixins(PropertyCommons) {
  @Prop({ required: true })
  public value!: string;

  @Prop({ required: true, type: Array })
  public options!: Array<any>;

  get selectedId(): string {
    return this.value;
  }

  set selectedId(newValue: string) {
    this.$emit('input', newValue);
  }

  @Emit('change')
  onChange(e: Event) {
    return e;
  }
}
